import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import { compose } from 'redux';
import cn from 'classnames';
import { productPropTypes } from '../../Product';
import Cards from '../../ContentTray/Cards';
import { colourThemeType } from '../../../propTypes';
import theme, { sliceColourTheme } from '../../../styles/theme';
import {
  getProductsWithVisibility,
  isProductsReadyOrError,
} from '../../../selectors/products';

import SponsoredProduct from './SponsoredProduct';

const SponsoredProducts = ({
  className,
  classes,
  products,
  ready,
  sliceId,
  colourTheme,
  adId,
}) => (
  <Cards
    className={cn(className, classes.cards)}
    Card={SponsoredProduct}
    cards={products}
    ready={ready}
    sliceId={sliceId}
    colourTheme={colourTheme}
    adId={adId}
  />
);

SponsoredProducts.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape(productPropTypes)).isRequired,
  ready: PropTypes.bool.isRequired,
  sliceId: PropTypes.number.isRequired,
  colourTheme: colourThemeType,
  adId: PropTypes.string,
};

SponsoredProducts.defaultProps = {
  className: undefined,
  colourTheme: sliceColourTheme.white,
  adId: undefined,
};

const mapStateToProps = (state, { sliceId }) => ({
  products: getProductsWithVisibility(state, sliceId),
  ready: isProductsReadyOrError(state, sliceId),
});

const styles = {
  cards: {
    marginLeft: -8,
    marginRight: -8,
    '&:has(.ti-cs-swiper-buttons)': {
      [theme.breakpoints.up('md')]: {
        marginTop: 65,
      },
    },
    '& .ti-cs-side-scroller-card-item:first-child': {
      marginLeft: '8px',
    },
    '& .ti-cs-side-scroller-card-item:last-child': {
      marginRight: '8px',
    },
  },
};

export default compose(
  connect(mapStateToProps),
  injectSheet(styles),
)(SponsoredProducts);
